import IconSwitcher from '@components/common/IconSwitcher';
import { CSS_HELPERS, THEME_COLORS } from '@theme/constants';
import { Button, Typography } from 'antd';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import React from 'react'
import { BsCalculator } from 'react-icons/bs';
import styled from 'styled-components';


const SimuladorButton = ({ slug }) => {
    const router = useRouter();

    return (
        <Link href={`/simulador/${slug}`}>
            <Card >
                <CardHeader>
                    <IconCircle>
                        <BsCalculator size={45} />
                    </IconCircle>
                </CardHeader>
                <CardBody>
                    <Typography.Title level={4}>
                        SIMULAR INVERSIÓN
                    </Typography.Title>
                </CardBody>
            </Card>
        </Link>


    )
}

export default SimuladorButton;



const Card = styled.div`
    max-width:21em;
    display:flex;
    border-radius:10pt;
    overflow: hidden;
    ${CSS_HELPERS.BOX_SHADOW};
    cursor:pointer;
    height:4.5em;
    border: 3pt solid ${THEME_COLORS.light.bg.alt};
    :hover{
        border: 3pt solid ${THEME_COLORS.light.secondary.main};
    }
    ${CSS_HELPERS.TSCALE}
`;

const CardHeader = styled.div`
    display:flex;
    justify-content:center ;
    align-items:center;
    width:6em;
`;


const IconCircle = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    svg{
        fill: ${THEME_COLORS.light.primary.main};
    };
`


const CardBody = styled.div`
width: 100%;
display:flex;
align-items:center;
background-color: ${THEME_COLORS.light.primary.main};
padding-left:1em;

.ant-typography, p { 
    color: ${THEME_COLORS.light.primary.contrastText};
    margin:0;
}
:hover{
    background-color: ${THEME_COLORS.light.primary.main}cc;
    transition: background-color .3s linear;
}


`;
